module.exports = __webpack_public_path__ + "static/SocialDropHero-43f97bc778d8b55d33aabb3c02f10395.svg";